module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_8-ccd24b8456e01a1283fe27caf2da82ba.png";